import '../assets/styles/css/index.css'

import { useState } from 'react'
import NavBarTop from '../components/NavBarTop'
import Legal from '../components/Legal'

const LegalContainer = () => {
  const [select, setSelect] = useState([
    { isSelected: false, type: 'avisoLegal' },
    { isSelected: false, type: 'politicaPrivacidad' },
    { isSelected: false, type: 'politicaCookies' },
    { isSelected: false, type: 'whatsappGroups' },
  ])
  const [isStiky, setIsStiky] = useState(false)

  const handleChangeSelected = (select) => {
    setSelect((prevState) => {
      return prevState.map((item) => ({
        ...item,
        isSelected: select === item.type,
      }))
    })
  }

  return (
    <div className={'wrapper'}>
      <div className={'navBar'}>
        <NavBarTop />
      </div>
      <div className={`${'container'} container`}>
        <Legal
          fixSticky={(isStiky) => setIsStiky(!isStiky)}
          isStiky={isStiky}
          select={select}
          type={(select) => handleChangeSelected(select)}
        />
      </div>
    </div>
  )
}

export default LegalContainer
